/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Restore_If_App_Store_SubscribedInputs */

const en_plan_restore_if_app_store_subscribed = /** @type {(inputs: Plan_Restore_If_App_Store_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore purchases if you subscribed with the app stores.`)
};

const es_plan_restore_if_app_store_subscribed = /** @type {(inputs: Plan_Restore_If_App_Store_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaura compras si te suscribiste desde las tiendas de apps.`)
};

/**
* | output |
* | --- |
* | "Restore purchases if you subscribed with the app stores." |
*
* @param {Plan_Restore_If_App_Store_SubscribedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_restore_if_app_store_subscribed = /** @type {((inputs?: Plan_Restore_If_App_Store_SubscribedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Restore_If_App_Store_SubscribedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_restore_if_app_store_subscribed(inputs)
	return en_plan_restore_if_app_store_subscribed(inputs)
});